import React from "react";
import { connect } from 'react-redux';
import AddressForm from "./AddressForm";
import * as Yup from "yup";
import * as actions from './store/addressActions';
import History from "../../../../History";
import { hasPermission, parseURL } from "../../../sc-utilities";
import { states, getStatesList, getCountryList } from '../../../sc-utilities/CountriesAndUSstatesList';
import countries from 'i18n-iso-countries';

const AddressCreate = props => {
    const { activeCustomerID, translations, userLanguage, permissions, createAddress } = props;
    const searchParams = parseURL(window.location.href);

    try {
        let lang = userLanguage;
        if (userLanguage.includes("zh-")) {
            lang = "zh";
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`));
    } catch (error) {
        console.log(error)
    }

    const handleSubmit = async data => {
        let formData = { ...data };

        formData['Country'] = data?.Country?.key;
        if (data?.Country?.key === 'US' || data?.Country === 'US') {
            formData['State'] = data?.State?.value;
        } else {
            formData['State'] = null;
        }

        let result = await createAddress({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        City: "",
        Country: "",
        AddressLine1: "",
        AddressLine2: "",
        State: "",
        GLN: ""
    };

    let formSettings = {
        Validation: {
            City: Yup.string().required(),
            Country: Yup.string().required(),
            AddressLine1: Yup.string().required(),
            AddressLine2: Yup.string().required(),
            State: Yup.string().notRequired(),
            GLN: Yup.string().required()
        },
        FormTitle: translations["create_address"] || "Create address",
        ButtonSubmit: hasPermission(permissions, 'address_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        <AddressForm
            countryList={getCountryList(countries, userLanguage)}
            usStatesList={getStatesList(states)}
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            translations={translations}
        />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createAddress: data => dispatch(actions.createAddress(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressCreate);
